<template>
  <b-card>
    <b-container>
      <b-row>
        <b-col>
          <h1>Thank you!</h1>
          <br />
          <p>Your Order ({{ order.OrderCode }}) has been received and a
            confirmation email with your receipt has been emailed to <b-link
              class="item-highlight"
              :href="'mailto:' + order.OrderContactInformation.Email"
              >{{ order.OrderContactInformation.Email }}</b-link
            >.
            Your order is currently being processed and when it is complete, you
            will receive a second email with links to retrieve your list.</p>
          <p>
            *Please make sure that your email’s spam/junk folder is set to allow
            emails from
            <b-link :href="'mailto:' + this.$store.state.site.ContactEmail">{{
              this.$store.state.site.ContactEmail
            }}</b-link
            >. Orders are fulfilled within 4 hours, typically in less than 30
            minutes during normal business hours (Mon-Fri, 8am-6pm EST). Orders
            placed after hours from new customers may be placed on hold for
            confirmation and are typically fulfilled within one business day.
          </p>
          <p>
            If you have any questions about your order, please contact us at
            <b-link
              class="item-highlight"
              :href="'tel:' + this.$store.state.site.PhoneNumber"
              >{{ this.$store.state.site.PhoneNumber }}</b-link
            >
            or at
            <b-link
              class="item-highlight"
              :href="'mailto:' + this.$store.state.site.ContactEmail"
              >{{ this.$store.state.site.ContactEmail }}</b-link
            >.
          </p>
          <table class="table">
            <tr>
              <td>Order Number</td>
              <td data-test="success-orderCode">{{ order.OrderCode }}</td>
            </tr>
            <tr>
              <td>Order Name</td>
              <td data-test="success-orderDesc">
                {{ order.OrderContactInformation.OrderName }}
              </td>
            </tr>
            <tr>
              <td>Order Date</td>
              <td data-test="success-orderDate">
                {{ order.OrderSubmittedDate | formatDate }}
              </td>
            </tr>
            <tr>
              <td>Qty Available</td>
              <td data-test="success-availableQty">
                {{ order.TotalAvailableQty | numberFormat("", 0) }}
              </td>
            </tr>
            <tr>
              <td>Qty Selected</td>
              <td data-test="success-selectedQty">
                {{ order.TotalDesiredQty | numberFormat("", 0) }}
              </td>
            </tr>
            <!--<tr>-->
            <!--<td>Discount Values</td>-->
            <!--<td></td>-->
            <!--</tr>-->
            <!-- <tr>
              <td>Tax</td>
              <td data-test="success-tax">
                {{ order.TaxCharge | numberFormat }}
              </td>
            </tr> -->
            <tr>
              <td>Total Charge</td>
              <td data-test="success-totalCharge">
                {{ totalCharge | numberFormat }}
              </td>
            </tr>
          </table>
          <b-link :href="indexUrl" class="btn" variant="primary" data-test="success-goHome"
            >Home</b-link
          >
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import utils from "@/assets/utils";
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    goHome() {
      this.$router.push({ name: "landing" });
    },
  },
  computed: {
    indexUrl() {
      return this.$store.state.site.HomePageLink && this.$store.state.site.HomePageLink !== ""
        ? this.$store.state.site.HomePageLink
        : utils.getRootPath();
    },
    site() {
      return this.$store.state.site;
    },
    order() {
      return this.$store.state.order;
    },
    totalCharge() {
      return this.order.TotalPretaxCost + this.order.TaxCharge;
    },
  },
};
</script>

<style scoped lang="scss">
.row-placeorder {
  margin-top: 16px;
  display: block;
}

.row-placeorder-btn {
  float: right;
}

.bottom-btn {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/Success.vue